<template>
  <div class="scale">
    <div
      :style="`width: ${rulerWidth}px`"
      class="scale-ruler"
    >
    </div>
    <div class="number">{{ size }}m</div>
  </div>
</template>

<script>
import map from '@/mixins/map.js';

export default {
  data() {
    return {
      size: 3, // NOTE: ルーラーの長さメートル単位
    };
  },
  computed: {
    baseDomRect: ({$store}) => $store.state.map.baseDomRect,
    currentBuildingId: ({ $store }) => $store.state.current.buildingId,
    currentBuilding: ({ $store, currentBuildingId }) => $store.getters['area/buildingFind'](currentBuildingId),
    rulerWidth() {
      const meterToPx = this.baseDomRect.width / this.currentBuilding.width;
      return meterToPx * this.size;
    },
  },
}
</script>

<style scoped lang="scss">
.scale {
  position: absolute;
  bottom: 10px;
  right: 40px;
  text-align: right;
  font-size: 24px;
  pointer-events: none;
  &-ruler {
    float: right;
    height: 4px;
    border: 2px solid #fff;
    background: #6c6c6c;
  }
  .number {
    clear: both;
    text-shadow:
       1px  1px 0px #fff,
      -1px -1px 0px #fff,
      -1px  1px 0px #fff,
       1px -1px 0px #fff,
       0px  1px 0px #fff,
       0px -1px 0px #fff,
      -1px  0px 0px #fff,
       1px  0px 0px #fff
    ;
  }
}
</style>



// WEBPACK FOOTER //
// scale_ruler.vue?8576d676